import { get } from 'utils/lodash'

export const transformInventoryContainers = (containers = []) =>
  containers.map(container => ({ ...container, containerName: get(container, 'name', ''), isInventoryContainer: true }))
